var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadTabletBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 780,
    height: 296,
    viewBox: "0 0 780 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 77.586V296L258.802 218.411V0L0 77.586Z",
    fill: "url(#paint0_linear_20881_177)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.802 77.586V296L517.604 218.411V0L258.802 77.586Z",
    fill: "url(#paint1_linear_20881_177)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M521.198 77.586V296L780 218.411V0L521.198 77.586Z",
    fill: "url(#paint2_linear_20881_177)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20881_177",
    x1: 0,
    y1: 147.998,
    x2: 258.802,
    y2: 147.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00123F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#081B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1D3360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#405A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F6B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20881_177",
    x1: 258.802,
    y1: 147.998,
    x2: 517.604,
    y2: 147.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00123F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#081B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1D3360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#405A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F6B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20881_177",
    x1: 521.198,
    y1: 147.998,
    x2: 780,
    y2: 147.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00123F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#081B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1D3360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#405A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F6B99"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadTabletBg);
export default __webpack_public_path__ + "static/media/headTabletBg.5062f5e8f0d5ac8c8c7e9067e13a18f3.svg";
export { ForwardRef as ReactComponent };